import AssociatedData from "./Model/AssociatedData"
import RoleData from "./Model/RoleData"
import { ObservableFromFetch } from "../ObservableFromFetch"

export interface UpdateUserDetailParams {
  ApplicationUserID: number
  UserName: string
  FirstName: string
  LastName: string
  EmailAddressList: AssociatedData[]
  PhoneNumberList: AssociatedData[]
  RoleList: RoleData[]
  ModifiedBy: string
  ParticipationID: number
  Link: string
  // Not Used: ParticipantNotificationDetails: any[]
  IsUser: boolean
  NotificationEventIDs: number[]
  NotificationServiceIDs: number[]
  NotificationMethodIDs: number[]
  IsNotificationEnabled: boolean
  isCollectorActive: boolean
  timeZoneID: number
  Inactive: boolean
  AccountID: number
  LocationID: number
}

export default function UserNotificationInfoUpdate(params: UpdateUserDetailParams) {
  const requestBody = JSON.stringify({
    ApplicationUserID: params.ApplicationUserID,
    EmailAddressList: params.EmailAddressList.map((item) => ({
      EmailAddress: item.ContactDetail,
      isActive: item.Active,
      DeliveryType: "EMAIL",
    })),
    FirstName: params.FirstName,
    IsNotificationEnabled: params.IsNotificationEnabled,
    IsUser: params.IsUser,
    LastName: params.LastName,
    Link: params.Link,
    ModifiedBy: params.ModifiedBy,
    NotificationEventIDs: params.NotificationEventIDs,
    NotificationServiceIDs: params.NotificationServiceIDs,
    NotificationMethodIDs: params.NotificationMethodIDs,
    ParticipationID: params.ParticipationID,
    PhoneNumberList: params.PhoneNumberList.map((item) => ({
      PhoneNumber: item.ContactDetail,
      isActive: item.Active,
      DeliveryType: item.DeliveryType,
    })),
    RoleList: params.RoleList.map((item) => ({
      RoleID: item.RoleID,
      RoleTitle: item.Title,
      IsActive: item.Active,
      Locations: item.Locations,
    })),
    UserName: params.UserName,
    timeZoneID: params.timeZoneID,
    isCollectorActive: params.isCollectorActive,
    Inactive: params.Inactive,
  })

  return ObservableFromFetch<string>("FFOrderUserFileMaintenance/UpdateUserNotification", requestBody)
}
